import { graphql } from 'react-relay';

import { BookPaginator_query$key } from '../../../relay/__generated__/BookPaginator_query.graphql';
import FragmentPaginator, { FragmentPaginatorProps } from '../../core/FragmentPaginator';

const BookPaginator_query = graphql`
  fragment BookPaginator_query on Query
  @argumentDefinitions(
    filters: { type: BookFilter }
    order: { type: BookOrder }
    first: { type: Int }
    after: { type: String }
  )
  @refetchable(queryName: "BookPaginatorRefreshQuery") {
    books(filters: $filters, order: $order, first: $first, after: $after)
      @connection(key: "BookPaginator_query_books") {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          title
          publisher
          unitAs {
            id
            title
          }
        }
      }
    }
  }
`;

type Props = {} & Omit<FragmentPaginatorProps<BookPaginator_query$key>, 'fragment'>;

const BookPaginator = ({ ...props }: Props) => <FragmentPaginator fragment={BookPaginator_query} {...props} />;

export default BookPaginator;
